import React from "react";
import { useHistory } from "react-router-dom";
import { DmErrorScreen } from "dm-react-ui";
import { I18n } from "@aws-amplify/core";
import { ArrowLeftOutlined } from "@ant-design/icons";

export const Error404 = (props) => {
    const history = useHistory();
    return <DmErrorScreen
        error="404"
        titleText={I18n.get("It seems we got lost in space")}
        descriptionText={I18n.get("The site you are trying to access does not exist. Quiet traveler, we help you.")}
        actionText={I18n.get("Go back")}
        actionIcon={<ArrowLeftOutlined />}
        onClick={() => history.goBack()}
    />
}